<template>
  <div>
    <b-collapse
      v-if="!isFilterLoading"
      class="card show"
      animation="slide"
      aria-id="contentIdForA11y3"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11y3"
          :aria-expanded="props.open"
        >
          <p class="card-header-title">Filter applications</p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
          </a>
        </div>
      </template>

      <div class="card-content filter-columns">
        <div class="columns">
          <div class="column is-half">
            <b-field label="Application time">
              <b-select
                placeholder="Display applications that changed in the last:"
                v-model="filter.time"
                expanded
              >
                <option value="1">24 hours</option>
                <option value="2">48 hours</option>
                <option value="7">week</option>
                <option value="30">month</option>
              </b-select>
            </b-field>

            <b-field label="Intake">
              <multiselect
                v-model="filter.intake"
                :options="filterOptions.intake"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Student name">
              <multiselect
                v-model="filter.student"
                :options="filterOptions.student"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="University">
              <multiselect
                v-model="filter.university"
                placeholder="Search or add a tag"
                tag-placeholder="Add this as new tag"
                tag-position="top"
                track-by="title"
                label="title"
                :options="filterOptions.universities"
                :multiple="true"
                :taggable="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                :preselect-first="false"
                @tag="addTagUniversityTitle"
              >
                <template slot="option" slot-scope="{ option }">
                  <div v-if="option.id" class="media">
                    <div class="media-left">
                      <img width="32" :src="option.img_url" />
                    </div>
                    <div class="media-content">
                      {{ option.title }}
                      <br />
                      <small> Address: {{ option.address }} </small>
                      <br />
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-field>

            <b-field label="University campus">
              <multiselect
                v-model="filter.address"
                placeholder="Search or add a tag"
                tag-placeholder="Add this as new tag"
                track-by="address"
                label="address"
                :options="filterOptions.universities"
                :multiple="true"
                :taggable="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                :preselect-first="false"
                @tag="addTagUniversityAdress"
              >
                <template slot="option" slot-scope="{ option }">
                  <div v-if="option.id" class="media">
                    <div class="media-left">
                      <img width="32" :src="option.img_url" />
                    </div>
                    <div class="media-content">
                      {{ option.title }}
                      <br />
                      <small> Address: {{ option.address }} </small>
                      <br />
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-field>

            <b-field label="Status">
              <multiselect
                v-model="filter.status"
                :options="filterOptions.status"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span :class="getRowClass(option.value, false)">
                    <span>{{ option.value }}</span>
                    <span class="multiselect__tag-icon" @click="remove(option)">
                    </span>
                  </span>
                </template>
              </multiselect>
            </b-field>

            <b-field label="Screenshots">
              <b-checkbox v-model="filter.needsScreenShootApproval">
                Show only applications that need screenshot approval
              </b-checkbox>
            </b-field>
          </div>

          <div class="column is-half">
            <b-field label="Agents">
              <multiselect
                v-model="filter.moderator"
                :options="filterOptions.moderator"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Course">
              <multiselect
                v-model="filter.course"
                :options="filterOptions.course"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Teams">
              <multiselect
                v-model="filter.teams"
                :options="filterOptions.teams"
                track-by="teamId"
                label="username"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
                <template slot="option" slot-scope="{ option }">
                  <span class="">{{ parseTeam(option) }}</span>
                </template>
              </multiselect>
            </b-field>

            <b-field label="Student Finance Status">
              <multiselect
                v-model="filter.studentFormStatus"
                :options="filterOptions.studentFormStatus"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Upfront Status">
              <multiselect
                v-model="filter.upfrontStatus"
                :options="filterOptions.upfrontStatus"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Final Status">
              <multiselect
                v-model="filter.finalSatus"
                :options="filterOptions.finalStatus"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <div class="field">
              <b-field label="Students per page">
                <b-select v-model="filterPerPage">
                  <option
                    v-for="option in filterPerPageOptions"
                    :value="option.value"
                    :key="option.value"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
          <div class="block column is-full">
            <b-button type="is-primary" @click="resetQuery"
              >Reset search</b-button
            >
            <b-button
              type="is-primary"
              style="margin-left: 15px"
              @click="regenerateFilters"
              >Regen filters</b-button
            >
            <b-button
              v-if="isAdmin"
              style="margin-left: 15px"
              @click="downloadData"
              >Download data</b-button
            >
          </div>
        </div>
      </div>
    </b-collapse>

    <b-table
      v-if="!isFilterLoading"
      class="app-table"
      mobile-cards
      paginated
      :per-page="filterPerPage"
      :data="filteredApplications"
      detail-key="id"
      show-detail-icon
      sticky-header
      :row-class="(row) => getRowClass(row, true)"
    >
      <b-progress
        v-if="numberOfStudentsFiltered.show"
        :value="getNumberOfFilteredStudents"
        size="is-medium"
        type="is-success"
        class="my-4"
        show-value
      >
        {{ numberOfStudentsFiltered.filtered }} of
        {{ numberOfStudentsFiltered.initial }} applications being displayed
      </b-progress>
      <b-table-column v-slot="props" label="SFE Form" width="40">
        <div>
          <b-button
            v-if="
              (props.row.studentForm &&
                props.row.studentForm.studentFormStatus !== 'Approved') ||
              !props.row.studentForm
            "
            tag="router-link"
            :to="{
              name: 'sfe-form',
              params: {
                id: props.row.studentId,
                studentFormProp: props.row.studentForm,
                templateOptions: props.row.studentData,
                fullCourse: props.row.fullCourse,
                appRow: props.row,
              },
            }"
            type="is-warning"
            style="margin-top: 4px"
          >
            {{ studentFormActionLabel(props.row) }}
          </b-button>
          <b-button
            v-if="
              props.row.studentForm &&
              props.row.studentForm.studentFormStatus === 'Info required'
            "
            @click="submitStatus(props.row, 'studentFormStatus')"
            style="margin-top: 4px"
          >
            Resend Form
          </b-button>
          <b
            v-if="
              props.row.studentForm &&
              props.row.studentForm.studentFormStatus === 'Approved'
            "
          >
            <b-icon icon="check-decagram" type="is-success"></b-icon>
          </b>
        </div>
      </b-table-column>
      <b-table-column field="status" label="Status" width="160" v-slot="props">
        <div
          v-if="
            isEditingStatus === props.row.studentId &&
            isEditingType === 'studentFormStatus'
          "
        >
          <b-field class="column is-full">
            <b-autocomplete
              v-model="financeStatus"
              :data="filteredEditCellData"
              open-on-focus
              rounded
              clearable
              @select="(option) => (selected = option)"
              @keyup.native.enter="submitStatus(props.row, 'studentFormStatus')"
            ></b-autocomplete>
          </b-field>
          <div class="buttons column is-full d-flex justify-content-around">
            <b-icon
              style="cursor: pointer"
              @click.native.prevent="setEditingStatus(false, null)"
              label="Cancel"
              icon="cancel"
              type="is-danger"
            ></b-icon>
            <b-icon
              style="cursor: pointer; margin-left: 12px"
              @click.native.prevent="
                submitStatus(props.row, 'studentFormStatus')
              "
              label="Finish"
              icon="check-circle-outline"
              type="is-primary"
            ></b-icon>
          </div>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="isManagement && props.row.studentForm"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              setEditingStatus(
                props.row.studentId,
                'studentFormStatus',
                'financeStatus',
                props.row.studentForm.studentFormStatus
              )
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{
              props.row.studentForm && props.row.studentForm.studentFormStatus
                ? props.row.studentForm.studentFormStatus
                : ''
            }}
          </span>
        </div>
      </b-table-column>
      <b-table-column
        field="SFE Last updated"
        label="SFE Last updated"
        width="40"
        v-slot="props"
      >
        {{ props.row.studentForm && props.row.studentForm.sfeLastUpdated }}
      </b-table-column>
      <b-table-column
        field="prinscreen"
        label="Prinstcreen"
        width="40"
        v-slot="props"
      >
        <b-dropdown aria-role="list">
          <template #trigger="{ active }">
            <b-button
              :label="screenshotLabel(props.row.studentForm)"
              type="is-primary"
              :icon-right="active ? 'menu-up' : 'menu-down'"
            />
          </template>
          <b-dropdown-item
            @click.native.prevent="approvePrinscreen(props.row)"
            v-if="isAdmin"
            aria-role="listitem"
          >
            Approve
          </b-dropdown-item>
          <b-dropdown-item
            v-if="
              !props.row.studentForm ||
              (props.row.studentForm && !props.row.studentForm.printscreenUrl)
            "
            aria-role="listitem"
          >
            <b-field
              class="file is-primary"
              :class="{ 'has-name': !!printscreenFile }"
            >
              <b-upload
                :native="true"
                v-model="printscreenFile"
                @input="selectedDocs($event, props.row.studentId, props.row)"
                class="file-label"
              >
                <span class="file-cta">
                  <b-icon class="file-icon" icon="upload"></b-icon>
                  <span class="file-label">Upload printscreen</span>
                </span>
                <span class="file-name" v-if="printscreenFile">
                  {{ printscreenFile.name }}
                </span>
              </b-upload>
            </b-field>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.studentForm && props.row.studentForm.printscreenUrl"
            aria-role="listitem"
          >
            <a
              :href="props.row.studentForm.printscreenUrl"
              target="_blank"
              rel="noopener noreferrer"
              >View</a
            >
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.studentForm && props.row.studentForm.printscreenUrl"
            aria-role="listitem"
            @click.native.prevent="
              deletePrintScreen(props.row.studentId, props.row)
            "
          >
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </b-table-column>
      <b-table-column field="upfront" label="Upfront" width="40" v-slot="props">
        <b-dropdown
          v-if="
            props.row.studentForm && props.row.studentForm.printscreenApproved
          "
          aria-role="list"
        >
          <template #trigger="{ active }">
            <b-button
              :label="
                !props.row.studentForm.studentFormComments
                  ? 'Fill or View invoice'
                  : 'Fix invoice comments'
              "
              type="is-primary"
              :icon-right="active ? 'menu-up' : 'menu-down'"
            />
          </template>

          <b-dropdown-item
            v-if="props.row.studentForm && props.row.studentForm.upfrontForm"
            has-link
            aria-role="listitem"
          >
            <router-link
              :to="{
                name: 'payment-form',
                params: {
                  id: props.row.studentId,
                  studentFormProp: props.row.studentForm,
                  templateOptions: props.row.studentData,
                  fullCourse: props.row.fullCourse,
                  isUpfrontPayment: true,
                  isDownload: false,
                  isEdit: false,
                },
              }"
            >
              View
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.studentForm && props.row.studentForm.upfrontForm"
            has-link
            aria-role="listitem"
          >
            <router-link
              :to="{
                name: 'payment-form',
                params: {
                  id: props.row.studentId,
                  studentFormProp: props.row.studentForm,
                  templateOptions: props.row.studentData,
                  fullCourse: props.row.fullCourse,
                  isUpfrontPayment: true,
                  isDownload: true,
                  isEdit: false,
                },
              }"
            >
              Download
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="displayEditInvoice(props.row.studentForm.upfrontFormStatus)"
            has-link
            aria-role="listitem"
          >
            <router-link
              :to="{
                name: 'payment-form',
                params: {
                  id: props.row.studentId,
                  studentFormProp: props.row.studentForm,
                  templateOptions: props.row.studentData,
                  fullCourse: props.row.fullCourse,
                  isUpfrontPayment: true,
                  isDownload: false,
                  isEdit: true,
                },
              }"
            >
              {{ props.row.studentForm.upfrontForm ? 'Edit' : 'Create' }}
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
        <div v-else>Awaiting form approval or completion</div>
      </b-table-column>
      <b-table-column
        field="status"
        label="Upfront status"
        width="160"
        v-slot="props"
      >
        <div
          v-if="
            isEditingStatus === props.row.studentId &&
            isEditingType === 'upfrontFormStatus'
          "
        >
          <b-field class="column is-full">
            <b-autocomplete
              v-model="upfrontStatus"
              :data="filteredStatusData"
              open-on-focus
              rounded
              clearable
              @select="(option) => (selected = option)"
              @keyup.native.enter="submitStatus(props.row, 'upfrontFormStatus')"
            ></b-autocomplete>
          </b-field>
          <div class="buttons column is-full d-flex justify-content-around">
            <b-icon
              style="cursor: pointer"
              @click.native.prevent="setEditingStatus(false, '', null)"
              label="Cancel"
              icon="cancel"
              type="is-danger"
            ></b-icon>
            <b-icon
              style="cursor: pointer; margin-left: 12px"
              @click.native.prevent="
                submitStatus(props.row, 'upfrontFormStatus')
              "
              label="Finish"
              icon="check-circle-outline"
              type="is-primary"
            ></b-icon>
          </div>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="isAdmin && props.row.studentForm"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              setEditingStatus(
                props.row.studentId,
                'upfrontFormStatus',
                'upfrontStatus',
                props.row.studentForm.upfrontFormStatus
              )
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{
              props.row.studentForm && props.row.studentForm.upfrontFormStatus
                ? props.row.studentForm.upfrontFormStatus
                : ''
            }}
          </span>
        </div>
      </b-table-column>
      <b-table-column field="Final" label="Final" width="40" v-slot="props">
        <div
          v-if="
            isAdmin &&
            props.row.studentForm &&
            !props.row.studentForm.isFinalFormOpen
          "
        >
          <b-icon
            style="cursor: pointer; margin-left: 12px"
            @click.native.prevent="toggleFinalPayment(props.row)"
            label="Finish"
            icon="check-circle-outline"
            type="is-primary"
          ></b-icon>
        </div>

        <b-dropdown
          v-if="props.row.studentForm && props.row.studentForm.isFinalFormOpen"
          aria-role="list"
        >
          <template #trigger="{ active }">
            <b-button
              :label="
                !props.row.studentForm.studentFormComments
                  ? 'Fill or View invoice'
                  : 'Fix invoice comments'
              "
              type="is-primary"
              :icon-right="active ? 'menu-up' : 'menu-down'"
            />
          </template>

          <b-dropdown-item
            v-if="props.row.studentForm && props.row.studentForm.finalForm"
            has-link
            aria-role="listitem"
          >
            <router-link
              :to="{
                name: 'payment-form',
                params: {
                  id: props.row.studentId,
                  studentFormProp: props.row.studentForm,
                  templateOptions: props.row.studentData,
                  fullCourse: props.row.fullCourse,
                  isUpfrontPayment: false,
                  isDownload: false,
                  isEdit: false,
                },
              }"
            >
              View
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.studentForm && props.row.studentForm.finalForm"
            has-link
            aria-role="listitem"
          >
            <router-link
              :to="{
                name: 'payment-form',
                params: {
                  id: props.row.studentId,
                  studentFormProp: props.row.studentForm,
                  templateOptions: props.row.studentData,
                  fullCourse: props.row.fullCourse,
                  isUpfrontPayment: false,
                  isDownload: true,
                  isEdit: false,
                },
              }"
            >
              Download
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="displayEditInvoice(props.row.studentForm.finalFormStatus)"
            has-link
            aria-role="listitem"
          >
            <router-link
              :to="{
                name: 'payment-form',
                params: {
                  id: props.row.studentId,
                  studentFormProp: props.row.studentForm,
                  templateOptions: props.row.studentData,
                  fullCourse: props.row.fullCourse,
                  isUpfrontPayment: false,
                  isDownload: false,
                  isEdit: true,
                },
              }"
            >
              {{ props.row.studentForm.finalForm ? 'Edit' : 'Create' }}
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
        <div v-else>Not yet open</div>
      </b-table-column>
      <b-table-column
        field="final_status"
        label="Final status"
        width="40"
        v-slot="props"
      >
        <div
          v-if="
            isEditingStatus === props.row.studentId &&
            isEditingType === 'finalFormStatus'
          "
        >
          <b-field class="column is-full">
            <b-autocomplete
              v-model="finalStatus"
              :data="filteredStatusData"
              open-on-focus
              rounded
              clearable
              @select="(option) => (selected = option)"
              @keyup.native.enter="submitStatus(props.row, 'finalFormStatus')"
            ></b-autocomplete>
          </b-field>
          <div class="buttons column is-full d-flex justify-content-around">
            <b-icon
              style="cursor: pointer"
              @click.native.prevent="setEditingStatus(false, '', null)"
              label="Cancel"
              icon="cancel"
              type="is-danger"
            ></b-icon>
            <b-icon
              style="cursor: pointer; margin-left: 12px"
              @click.native.prevent="submitStatus(props.row, 'finalFormStatus')"
              label="Finish"
              icon="check-circle-outline"
              type="is-primary"
            ></b-icon>
          </div>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="isAdmin && props.row.studentForm && props.row.studentForm"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              setEditingStatus(
                props.row.studentId,
                'finalFormStatus',
                'finalStatus',
                props.row.studentForm.finalFormStatus
              )
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{
              props.row.studentForm && props.row.studentForm.finalFormStatus
                ? props.row.studentForm.finalFormStatus
                : ''
            }}
          </span>
        </div>
      </b-table-column>

      <b-table-column field="name" label="Name" width="40" v-slot="props">
        {{ props.row.studentData.personalInformation.student_name }}
      </b-table-column>
      <b-table-column field="status" label="Status" width="40" v-slot="props">
        {{ props.row.status }}
      </b-table-column>
      <b-table-column field="updates" label="Updates" width="40" v-slot="props">
        {{ props.row.studentData.generalInfo.booking }}
      </b-table-column>
      <b-table-column
        field="university"
        label="University"
        width="40"
        v-slot="props"
      >
        {{ props.row.university.title }}
      </b-table-column>
      <b-table-column
        field="university"
        label="University"
        width="40"
        v-slot="props"
      >
        {{ props.row.university.title }}
      </b-table-column>
      <b-table-column field="campus" label="Campus" width="40" v-slot="props">
        {{ getCity(props.row.university.address) }}
      </b-table-column>
      <b-table-column
        field="course_name"
        label="Course name"
        width="40"
        v-slot="props"
      >
        <span class="cut-title" :title="props.row.courseTitle">{{
          props.row.courseTitle
        }}</span>
      </b-table-column>
      <b-table-column field="Agent" label="Agent" width="40" v-slot="props">
        {{ props.row.moderator }}
      </b-table-column>
      <b-table-column field="intake" label="Intake" v-slot="props" width="60">
        {{ props.row.studentData.personalInformation.intake }}
      </b-table-column>
      <b-table-column
        field="approved_date"
        label="Approved at"
        width="40"
        v-slot="props"
      >
        {{
          props.row.studentForm && props.row.studentForm.approved_date
            ? formaLocalDate(props.row.studentForm.approved_date)
            : 'Not approved'
        }}
      </b-table-column>
      <b-table-column
        field="team"
        label="Advisor team"
        width="40"
        v-slot="props"
      >
        {{ getAdvisorTeam(props.row.team) }}
      </b-table-column>
      <b-table-column
        field="approved_date"
        label="Approved at"
        width="40"
        v-slot="props"
      >
        {{
          props.row.studentForm && props.row.studentForm.approved_date
            ? formaLocalDate(props.row.studentForm.approved_date)
            : 'Not approved'
        }}
      </b-table-column>
      <b-table-column
        field="messages"
        label="Created at"
        width="40"
        v-slot="props"
      >
        {{ formaLocalDate(props.row.date) }}
      </b-table-column>
    </b-table>

    <b-loading
      is-full-page
      v-model="isFilterLoading"
      :can-cancel="false"
    ></b-loading>

    <b-modal
      v-model="isViewStudentModalActive"
      full-screen
      class="message-modal__app"
      @close="$router.push('/payment')"
    >
      <router-view></router-view>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import StudentService from '../services/student.service';
import UtilService from '../services/util';

import FilterService from '../services/filter';

import {
  passingOptionsClasses,
  studentMessageMapClass,
  studentMessageStatusMap,
  financeStatuses,
  paymentStatuses,
  statusOptionsClasses,
  // financeStatusClasses
} from '../models/static';

export default {
  name: 'uncon-list',
  components: {
    Multiselect,
  },
  data() {
    return {
      printscreenFile: null,
      application: {},
      savedQueries: [],
      isMessageModalActive: false,
      isViewStudentModalActive: false,
      selectedQueryName: null,
      oldStudentIntake: null,
      isEditingStatus: false,
      isEditingType: null,
      financeStatus: '',
      upfrontStatus: '',
      finalStatus: '',
      filterPerPageOptions: [
        {
          name: '50',
          value: 50,
        },
        {
          name: '100',
          value: 100,
        },
        {
          name: 'All',
          value: 100000,
        },
      ],
    };
  },
  created() {},
  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.isViewStudentModalActive = newVal.meta && newVal.meta.showModal;
      },
    },
  },
  computed: {
    filteredEditCellData() {
      return this.financeStatus
        ? financeStatuses.filter((option) => {
            return (
              option
                .toString()
                .toLowerCase()
                .indexOf(this.financeStatus.toLowerCase()) >= 0
            );
          })
        : financeStatuses;
    },
    filteredStatusData(status) {
      const toCheck =
        status === 'upfront' ? this.upfrontStatus : this.finalStatus;
      return toCheck
        ? paymentStatuses.filter((option) => {
            return (
              option.toString().toLowerCase().indexOf(toCheck.toLowerCase()) >=
              0
            );
          })
        : paymentStatuses;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    filteredApplications() {
      return FilterService.queryFilters(
        this.$store.state.application.applications,
        true
      ).filter(
        (app) =>
          app.status === 'Unconditional' ||
          app.status === 'Awaiting Uncon' ||
          app.status === 'Pending' ||
          app.studentForm
      );
    },
    editCell() {
      return this.$store.state.application.editCell;
    },
    filter: {
      get() {
        return this.$store.state.application_filter.filter;
      },
      set() {},
    },
    filterPerPage: {
      get() {
        return this.$store.state.application_filter.filterPerPage;
      },
      set(value) {
        this.$store.dispatch('application_filter/setFilterPerPage', value);
      },
    },
    isAdmin() {
      return UtilService.isAdmin();
    },
    isManagement() {
      return UtilService.isManagement();
    },
    getActiveConversation() {
      return UtilService.getActiveConversation();
    },
    isTeamLeader() {
      return UtilService.isTeamLeader();
    },
    getNumberOfFilteredStudents() {
      return (
        (this.numberOfStudentsFiltered.filtered /
          this.numberOfStudentsFiltered.initial) *
        100
      );
    },
    numberOfStudentsFiltered() {
      return {
        show: true,
        initial: this.$store.state.application.applications.length,
        filtered: this.filteredApplications.length,
      };
    },
    hasEditingRole() {
      return this.isManagement;
    },
    filterOptions() {
      const currentOptions = UtilService.deepCopy(
        this.$store.state.application_filter.filterOptions
      );
      return currentOptions && Object.keys(currentOptions)
        ? currentOptions
        : {};
    },
    originalUniversities() {
      return this.$store.state.application_filter.filterOptions.universities;
    },
    isFilterLoading() {
      return this.$store.state.application_filter.isFilterLoading;
    },
    changeStudentIntakeOptions() {
      return [
        {
          value: 'Current Intake',
        },
        ...this.filterOptions.intake,
      ];
    },
  },
  methods: {
    studentFormActionLabel(row) {
      if (!this.isManagement) {
        return row.studentForm &&
          row.studentForm.studentFormStatus === 'Awaiting review'
          ? 'Awaiting approval'
          : 'Complete form';
      } else {
        return row.studentForm ? 'View Form' : 'Fill Form';
      }
    },
    setEditingStatus(
      isEditingStatus,
      isEditingType,
      financeType,
      financeStatus
    ) {
      if (financeType) {
        this[financeType] = financeStatus;
      }

      this.isEditingStatus = isEditingStatus;
      this.isEditingType = isEditingType;
    },
    screenshotLabel(row) {
      if (!row || !row.printscreenUrl) {
        return 'Upload Proof';
      } else if (!row.printscreenApproved) {
        return 'Not yet approved';
      }

      return 'Approved';
    },
    resetQuery() {
      this.$store.dispatch('application_filter/resetFilterData');
      this.savePrefferedQuery(null, true);
      this.$store.dispatch('application/toggleEditCell', null);
    },

    regenerateFilters() {
      this.$store.dispatch('application_filter/setInitialFilters', {
        apps: FilterService.queryFilters(
          this.$store.state.application.applications
        ),
        universities: this.originalUniversities,
        finishedLoading: true,
      });
    },

    downloadData() {
      const mappedData = UtilService.arrayToCsv(
        this.mapStudentDataForCSV(this.filteredApplications)
      );
      const fileName = `StudentApplication_${UtilService.formatDate(
        new Date()
      )}.csv`;
      UtilService.downloadBlob(mappedData, fileName, 'text/csv;charset=utf-8;');
    },
    getRowClass(row, isObject) {
      let rowStatus = null;
      if (row && row.studentForm && isObject) {
        rowStatus = row.studentFormComments
          ? 'status-info-required'
          : (row.studentForm.upfrontForm &&
              row.studentForm.upfrontFormStatus !== 'Paid' &&
              !row.studentFormComments) ||
            (row.studentForm.finalForm &&
              row.studentForm.finalFormStatus !== 'Paid' &&
              !row.studentFormComments)
          ? 'status-booked'
          : row.studentForm.upfrontFormStatus === 'Paid' ||
            row.studentForm.finalFormStatus === 'Paid'
          ? 'status-success'
          : '';
      }

      if (!isObject) {
        rowStatus =
          row && !statusOptionsClasses[row]
            ? 'status-nude'
            : statusOptionsClasses[row];
      }

      return {
        [`${
          !isObject ? 'multiselect__tag status-tag' : 'app-table__row'
        } ${rowStatus}`]: true,
      };
    },
    mapStudentDataForCSV(applications) {
      return applications.map((app) => {
        const upfrontForm =
          app.studentForm && app.studentForm.upfrontForm
            ? JSON.parse(app.studentForm.upfrontForm)
            : null;
        const upFrontTotal = upfrontForm
          ? `${upfrontForm.payment
              .map((student) => parseInt(student.money))
              .reduce((partialSum, a) => partialSum + a, 0)} £`
          : '';
        const finalForm =
          app.studentForm && app.studentForm.finalForm
            ? JSON.parse(app.studentForm.finalForm)
            : null;
        const finalTotal = finalForm
          ? `${finalForm.payment
              .map((student) => parseInt(student.money))
              .reduce((partialSum, a) => partialSum + a, 0)} £`
          : '';

        return {
          'Student Name': app.studentData.personalInformation.student_name,
          University: app.university.title,
          Intake: app.studentData.personalInformation.intake,
          Agent: app.moderator,
          'Upfront Invoice No': upfrontForm ? upfrontForm.invoiceNo : '',
          'Upfront Total': upFrontTotal,
          'Final Invoice No': finalForm ? finalForm.invoiceNo : '',
          'Final Total': finalTotal,
          'Approved at':
            app.studentForm && app.studentForm.approved_date
              ? UtilService.formatDate(app.studentForm.approved_date)
              : 'Not yet approved',
        };
      });
    },
    getAdvisorTeam(team) {
      if (team.teamId && this.filterOptions.teams.length) {
        const foundTeam = this.filterOptions.teams.filter(
          (teams) => teams.teamId === team.teamId
        );
        if (foundTeam.length) {
          return this.parseTeam(foundTeam[0]);
        }
      }

      return '';
    },

    deletePrintScreen(studentId, appRow) {
      StudentService.deletePrintScreen({
        studentId,
      }).then(() => {
        const updateValue = {
          studentId,
          printscreenUrl: null,
        };

        this.updateEvent(
          appRow,
          updateValue,
          `studentForm.printscreenUrl`,
          'printscreenUrl'
        );
        this.setEditingStatus(false, '');
        this.$buefy.toast.open({
          duration: 3000,
          message: `Printscreen removed succesfully. Please refresh your page`,
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },

    selectedDocs(event, studentId, appRow) {
      var reader = new FileReader();
      reader.readAsDataURL(event);
      reader.onload = () => {
        StudentService.uploadPrintScreen({
          dataURI: reader.result,
          studentId,
        }).then((response) => {
          const updateValue = {
            studentId,
            printscreenUrl: response.data.printscreenUrl,
          };

          this.updateEvent(
            appRow,
            updateValue,
            `studentForm.printscreenUrl`,
            'printscreenUrl'
          );
          this.setEditingStatus(false, '');
          this.$buefy.toast.open({
            duration: 3000,
            message: `Printscreen uploaded succesfully. Please refresh your page`,
            position: 'is-bottom',
            type: 'is-success',
          });
        });
      };
      reader.onerror = function (error) {
        // eslint-disable-next-line no-console
        console.warn('Error: ', error);
      };
    },
    displayEditInvoice(status) {
      return !['Paid', 'Approved'].includes(status);
    },
    formaLocalDate(date) {
      return UtilService.formatDate(date);
    },
    submitStatus(appRow, type) {
      let updateValue = {
        studentId: appRow.studentId,
      };

      switch (type) {
        case 'upfrontFormStatus':
          updateValue[type] = this.upfrontStatus;
          break;

        case 'finalFormStatus':
          updateValue[type] = this.finalStatus;
          break;

        case 'studentFormStatus':
          updateValue[type] = this.financeStatus;
          if (
            (this.financeStatus === 'Application submitted' ||
              this.financeStatus === 'Approved') &&
            !appRow.studentForm.approved_date
          ) {
            updateValue['approved_date'] = new Date();
          }
          break;

        default:
          break;
      }

      StudentService.updateSFE(updateValue).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: `SFE status updated`,
          position: 'is-bottom',
          type: 'is-success',
        });

        if (updateValue[type] === 'Approved' || updateValue[type] === 'Paid') {
          updateValue.studentFormComments = null;
        }

        const path = `studentForm.${type}`;
        this.updateEvent(appRow, updateValue, path, type);

        this.setEditingStatus(false, '');
      });
    },

    approvePrinscreen(appRow) {
      const type = 'printscreenApproved';
      const path = `studentForm.${type}`;
      const updateValue = {
        studentId: appRow.studentId,
        printscreenApproved: true,
      };

      StudentService.updateSFE(updateValue).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Printscreen Approved👍`,
          position: 'is-bottom',
          type: 'is-success',
        });

        if (!appRow.studentForm) {
          this.$store.dispatch('application/toggleEditCell', {
            studentValue: appRow,
            path: ['studentForm'],
            value: updateValue,
            setData: false,
          });
        } else {
          this.updateEvent(appRow, updateValue, path, type);
        }

        this.setEditingStatus(false, '');
      });
    },

    updateEvent(appRow, updateValue, path, type) {
      this.$eventHub.$emit('socket__event', {
        messageType: 'socket__edit-application',
        messageValue: {
          path,
          studentValue: appRow.studentId,
          value: updateValue[type],
          setData: true,
        },
      });

      this.$store.dispatch('application/toggleEditCell', {
        studentValue: appRow,
        path,
        value: updateValue[type],
        setData: false,
      });
    },

    toggleFinalPayment(appRow) {
      const data = {
        studentId: appRow.studentId,
        isFinalFormOpen: !appRow.isFinalFormOpen,
      };

      StudentService.updateSFE(data).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: `SFE status updated`,
          position: 'is-bottom',
          type: 'is-success',
        });

        const path = `studentForm.isFinalFormOpen`;

        this.$eventHub.$emit('socket__event', {
          messageType: 'socket__edit-application',
          messageValue: {
            path,
            studentValue: appRow.studentId,
            value: data.isFinalFormOpen,
            setData: true,
          },
        });

        this.$store.dispatch('application/toggleEditCell', {
          studentValue: appRow,
          path,
          value: data.isFinalFormOpen,
          setData: false,
        });

        this.setEditingStatus(false, '');
      });
    },

    isTagSelected(optionName) {
      return this.selectedQueryName === optionName
        ? 'is-success'
        : 'is-primary';
    },

    getCity(address) {
      return address.substring(0, address.indexOf('-'));
    },

    studentName(student) {
      return student.first_name + ' ' + student.last_name + ' ';
    },

    deleteApplication(id) {
      this.$buefy.dialog.confirm({
        message:
          'Are you sure you want to delete application? This action cannot be undone',
        onConfirm: () => {
          StudentService.deleteApplication(id).then(() => {
            this.$store.dispatch('application/deleteApplication', id);

            this.$buefy.toast.open({
              duration: 3000,
              message: `Application succesfully deleted`,
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        },
      });
    },

    addTagUniversityAdress(newTag) {
      this.$store.dispatch('application_filter/addUniversityFilter', {
        address: newTag,
        title: newTag,
        type: 'address',
      });
    },

    addTagUniversityTitle(newTag) {
      this.$store.dispatch('application_filter/addUniversityFilter', {
        address: newTag,
        title: newTag,
        type: 'title',
      });
    },

    getCellClass(cell) {
      if (!cell || !cell.length) {
        return '';
      }

      const cellClass = !passingOptionsClasses[cell]
        ? 'status-booked'
        : passingOptionsClasses[cell];
      return `fake-bg-cell ${cellClass}`;
    },

    queryUniversities(queryString) {
      this.filterOptions.universities = queryString.length
        ? [...this.originalUniversities].filter(
            (university) =>
              university.title
                .toLowerCase()
                .includes(queryString.toLowerCase()) ||
              university.address
                .toLowerCase()
                .includes(queryString.toLowerCase())
          )
        : this.originalUniversities;
    },

    dateCheck(from, to, check) {
      return (
        Date.parse(check) <= Date.parse(to) &&
        Date.parse(check) >= Date.parse(from)
      );
    },

    toggleEditCell(studentValue, path, value, setData = false) {
      this.$store.dispatch('application/toggleEditCell', {
        studentValue,
        path,
        value,
        setData,
      });
    },

    displayCellEdit(id, fieldName) {
      return (
        this.editCell.id &&
        this.editCell.id === id &&
        this.editCell.fieldName === fieldName
      );
    },

    getUCBackground(status) {
      return studentMessageMapClass[status];
    },

    getUCText(text) {
      const foundText = studentMessageStatusMap.filter(
        (status) => status.id === text
      );
      return foundText && foundText.length ? foundText[0].value : text;
    },

    parseTeam(value) {
      return value.teamName + ' - ' + value.username;
    },
  },
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.card-content.filter-columns {
  width: 100%;
}

.space-between.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px;
}

.app-table .top.level {
  display: block;
}

.app-table__actions {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  min-width: 180px;
  justify-content: space-between;
  align-items: flex-end;
}

.multiselect__tag.status-tag,
.multiselect__tag.status-tag.status-nude {
  color: #363636;
}

.cut-title {
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table td {
  position: relative;
}

.edit-cell {
  display: flex;
  min-height: 24px;
  justify-content: flex-start;
  align-items: center;
}

.edit-cell__icon {
  cursor: pointer;
  margin-right: 4px;
}

.fake-bg-cell {
  padding: 0.5em 0.75em;
  border-radius: 12px;
}

.app-table__row {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.uc-app-cell {
  /* width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0; */
  color: white;
  padding: 8px;
  text-align: center;
}

/* .uc-app-cell > span {
      -webkit-writing-mode: vertical-rl;
      writing-mode: vertical-r1;
      transform: rotate(180deg);
      text-align: center;
  } */
</style>
